<template>
	<div class="wp wp-details">
		<figure class="wp-image">
			<BaseUiImage loading="lazy" :product="product?.main_image_thumbs?.['width120-height120']" default="/images/no-image-120.jpg" :alt="product.title" />
		</figure>

		<div class="wp-cnt">
			<div class="wp-inner-cnt">
				<h2 class="wp-title">{{ product.title }}</h2>
				<div class="wp-code"><BaseCmsLabel code="code" />: {{product.code}}</div>
				<div class="wp-variations" v-if="product.description">{{product.description}}</div>
			</div>
			<div class="wp-total-mobile">
				<div class="wp-price">
					<div :class="['product_total', (product.basic_price > product.price ? 'wp-price-current wp-price-discount' : 'wp-price-current')]"><BaseUtilsFormatCurrency :price="product.price" /></div>
				</div>
				<div class="wp-qty-count" v-if="parseInt(product.qty).toFixed(0) > 1">
					<span class="product_qty">{{ parseInt(product.qty).toFixed(0) }}</span> x <BaseUtilsFormatCurrency :price="product.price" />
				</div>
			</div>
			<BaseWebshopAddToCart v-slot="{onAddToCart, loading}" :data="{fetchId: product.product_id}" >
				<div class="btn btn-secondary btn-order-again" :class="{'loading': loading}" @click="onAddToCart">
					<UiLoader v-if="loading" /><span><BaseCmsLabel code="order_again" /></span>
				</div>
			</BaseWebshopAddToCart>
		</div>

		<div class="wp-total">
			<div class="wp-price">
				<div :class="['product_total', (product.basic_price > product.price ? 'wp-price-current wp-price-discount' : 'wp-price-current')]"><BaseUtilsFormatCurrency :price="product.price" /></div>
			</div>
			<div class="wp-qty-count" v-if="parseInt(product.qty).toFixed(0) > 1">
				<span class="product_qty">{{ parseInt(product.qty).toFixed(0) }}</span> x <BaseUtilsFormatCurrency :price="product.price" />
			</div>
		</div>
		
		<BaseWebshopAddToCart v-slot="{onAddToCart, loading}" :data="{fetchId: product.product_id}">
			<div class="btn btn-secondary btn-order-again-mobile" :class="{'loading': loading}" @click="onAddToCart">
				<UiLoader v-if="loading" /><span><BaseCmsLabel code="order_again" /></span>
			</div>
		</BaseWebshopAddToCart>
	</div>
</template>

<script setup>
	const props = defineProps(['product']);
</script>

<style lang="less" scoped>
	.wp{display: flex; padding: 22px 0; border-bottom: 1px solid var(--borderColor); margin-top: -1px;}
	.wp-image{
		flex-shrink: 0; display: flex; align-items: center; height: 150px; width: 175px; justify-content: center; padding: 2px;
		:deep(img){display: block; max-height: 100%; max-width: 100%; width: auto; height: auto; margin: auto;}
	}
	.wp-cnt{padding: 2px 25px; width: auto; flex-grow: 1; display: flex; justify-content: space-between; flex-flow: column;}
	.wp-inner-cnt{padding-bottom: 15px;}
	.wp-title{
		font-size: 20px !important; line-height: 26px; padding-top: 0; padding-bottom: 3px; font-weight: 300; color: var(--textColor);
		:deep(a){color: var(--textColor);}
	}
	.wp-code{color: rgba(43,44,55,0.5); font-size: 14px; line-height: 18px; padding-bottom: 3px;}
	
	.wp-total{text-align: right; padding-top: 45px; flex-shrink: 0; min-width: 245px; flex-shrink: 0; display: flex; flex-flow: column; align-items: flex-end;}
	.wp-price-current, .wp-price-discount{font-size: 24px; line-height: 26px; color: var(--textColor); font-weight: 400; padding-top: 20px;}
	.wp-price-discount{padding-top: 0 !important; font-weight: bold; color: var(--primaryColor);}
	.wp-price-old, .wp-qty-count{font-size: 14px; line-height: 20px;  text-align: right; color: var(--textColor); display: block; text-decoration: line-through;}
	.wp-qty-count{text-align: right; text-decoration: none; color: var(--textColor);}
	@media (max-width: @l){
		.wp{padding: 20px 0;}
		.wp-total{min-width: 225px;}
		.wp-price-current, .wp-price-discount{font-size: 22px; line-height: 26px;}
	}
	@media (max-width: @t){
		.wp{padding: 18px 0;}
		.wp-image{height: 105px; width: 95px;}
		.wp-title{font-size: 16px !important; line-height: 20px; padding-bottom: 2px;}
		.wp-code{font-size: 12px; line-height: 16px;}
		.wp-total{min-width: 170px; padding-top: 25px;}
		.wp-price-current, .wp-price-discount{font-size: 16px; line-height: 20px;}
		.wp-price-old, .wp-qty-count{font-size: 12px; line-height: 16px;}
		.wp-qty-count{padding-top: 1px;}
	}
	@media (max-width: @tp){
		.wp{padding: 15px 0;}
		.wp-cnt{padding: 2px 15px;}
	}
	@media (max-width: @m){
		.wp{padding: 13px 15px; display: flex; flex-wrap: wrap;}
		.wp-image{height: 95px; width: 85px;}
		.wp-cnt{padding: 1px 10px; padding-right: 0; width: calc(~"100% - 95px"); flex-grow: 1;}
		.wp-total{min-width: auto; padding-top: 8px; flex-grow: 1; display: flex; flex-flow: column; align-items: flex-end;}
		.wp-price-current, .wp-price-discount{font-size: 16px; line-height: 20px; display: flex; flex-flow: column;}
		.wp-price-old, .wp-qty-count{font-size: 10px; line-height: 14px;}
	}
</style>
